function DOMApply( root, selector, op )
{
    var elements = root.querySelectorAll( selector );
    elements.forEach( function( element )
    {
        op( element );
    } );
}

function CustomCountrySelectorOverride( e )
{
    //quick patch to fix live
    e.preventDefault( );
    e.stopPropagation( );

    var anchor  = e.currentTarget;
    var url     = anchor.href;

    var region = url.split( "?region=" )[ 1 ];

    var wrapper = anchor.closest( ".country_wrapper" );

    var form        = wrapper.querySelector( "localization-form" );
    var countryVal  = "GB";

    if( region == "us" )
    {
        countryVal = "US";
    }
    else if( region == "eu" )
    {
        countryVal = "FR";
    }
    else if( region == "de" )
    {
        countryVal = "DE";
    }

    var formAnchor = form.querySelector( ".disclosure__link[ data-value='" + countryVal + "' ]" );
    formAnchor.click();
}

function InitialiseFooterScript()
{
    window.addEventListener( "load", function( )
    {
        DOMApply( document, ".country_list_wrapper a", function( e ) { e.addEventListener( "click", CustomCountrySelectorOverride ); } );
    } );
}
InitialiseFooterScript();